/* global console */
import scriptLoader from 'utils/script-loader';
import logger from 'utils/logger';
import { createClass as createPluginClass } from 'player/plugins/model';

const plugins = {};

const Plugins = {
    register(plugin) {
        const name = plugin.getName();

        // register the same plugin only once
        if (!plugins[name]) {
            plugins[name] = createPluginClass(plugin);
        }
    },

    load(options) {
        // no plugins provided, complete immediately
        if (!options) {
            // timeout for proper event listener fire
            return Promise.resolve();
        }

        const scripts = Object.keys(options);

        const loadPlugin = async pluginSrc => {
            try {
                await scriptLoader(pluginSrc);
            } catch (error) {
                // eslint-disable-next-line no-console
                logger().error(`An error occur while loading ${pluginSrc}`);
            }

            return pluginSrc;
        };

        return Promise.all(scripts.map(loadPlugin));
    },

    get(name) {
        return plugins[name];
    }
};

export default Plugins;
